import {Component, inject, input} from '@angular/core';
import {IonIcon, IonSelect, IonSelectOption} from '@ionic/angular/standalone';
import {SelectCustomEvent} from '@ionic/angular';
import {addIcons} from 'ionicons';
import {globeOutline} from 'ionicons/icons';
import {Router, UrlSegment} from '@angular/router';
import {Lang} from '@models';
import {StorageService, TranslateHelperService} from '@services';

@Component({
	           selector: 'app-language-button',
	           standalone: true,
	           imports: [
		           IonIcon,
		           IonSelect,
		           IonSelectOption
	           ],
	           templateUrl: './language-button.component.html',
	           styleUrl: './language-button.component.scss'
           })
export class LanguageButtonComponent {
	public onLanguageChanged = input<(lang: string) => void>();
	public lang: string;
	public readonly translateService: TranslateHelperService = inject(TranslateHelperService);
	private storageService = inject(StorageService);
	private router = inject(Router);
	protected readonly languageList: Lang[] = [
		new Lang('en', '', 'English'),
		new Lang('fr', '', 'Français'),
		new Lang('it', '', 'Italiano'),
		new Lang('de', '', 'Deutsch'),
		new Lang('es', '', 'Español')
	];

	constructor() {
		this.lang = (this.translateService.currentLang || this.storageService.get('currentLang')) ?? 'en';
		addIcons({globeOutline});
	}

	public getLanguageLabel(shortCode: string): string {
		return Lang.shortCodeToLangue(shortCode);
	}

	public async switchLang(event: SelectCustomEvent<unknown>) {
		const nextLang = event.detail.value as string;
		if (!nextLang || nextLang === this.lang) {
			return;
		}
		this.lang = nextLang;

		await this.translateService.switchLanguage(this.lang);
		const callback = this.onLanguageChanged();
		if (callback) {
			await callback(this.lang);
		}

		const urlTree = this.router.parseUrl(this.router.url);
		const segments = urlTree.root.children['primary']?.segments ?? [];
		const hasLangPrefix = segments.length > 0 && this.languageList.some(lang => lang.shortCode === segments[0].path);
		const restSegments = hasLangPrefix ? segments.slice(1) : segments;
		const newSegments = [new UrlSegment(this.lang, {}), ...restSegments];
		if (urlTree.root.children['primary']) {
			urlTree.root.children['primary'].segments = newSegments;
			this.router.navigateByUrl(urlTree);
		} else {
			this.router.navigateByUrl(`/${this.lang}`);
		}
	}
}
